import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createAlert } from "components/Alert/Alert";
import { useAxiosWithAuth } from "Hooks/useAxiosWithAuth";
import { useNavigate } from "react-router-dom";


export const useClientProducts = (catId) => {
    const api = useAxiosWithAuth();

    const getData = async ({ queryKey }) => {
        const [_key, catId] = queryKey;

        const { data } = await api.get(`guest/products/${catId}`);
        return data;
    };

    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: ['client-products', catId],
        queryFn: getData,
        enabled: !!catId,
        retry: false,
    });
};

export const useClientProduct = (productId) => {
    const api = useAxiosWithAuth();

    const getData = async ({ queryKey }) => {
        const [_key, productId] = queryKey;

        const { data } = await api.get(`guest/product/${productId}`);
        return data;
    };

    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: ['client-product', productId],
        queryFn: getData,
        enabled: !!productId,
        retry: false,
    });
};

export const useCreateOrder = () => {
    const api = useAxiosWithAuth();
    const queryClient = useQueryClient()
    const navigate = useNavigate()
    const _add = async (formData) => {
        const { data } = await api.post(`user/order`, formData);
        return data;
    };

    return useMutation({
        mutationFn: _add,
        onSuccess: ({ data, type, message }) => {
            createAlert(type, message);
            navigate('/cp/my-orders')
        },
        onError: (error) => {
            console.error("Error updating data:", error.message);
        },
        retry: false,
    });
}

export const useMyOrders = (perPage = 10, page = 1, name = "", state = "") => {
    const api = useAxiosWithAuth();

    const getData = async ({ queryKey }) => {
        const [_key, perPage, page, name, state] = queryKey;

        const { data } = await api.get('user/orders', {
            params: {
                perPage,
                page,
                name, state
            },
        });
        return data;
    };

    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: ['my-orders', perPage, page, name, state],
        queryFn: getData,
        retry: false,
    });
};

export const useMyOrderById = (id) => {
    const api = useAxiosWithAuth();

    const getData = async ({ queryKey }) => {
        const [_key, id] = queryKey;

        const { data } = await api.get(`user/orders/${id}`);
        return data;
    };

    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: ['my-order-by-id', id],
        queryFn: getData,
        enabled: !!id,
        retry: false,
    });
};

export const useClientOffers = () => {
    const api = useAxiosWithAuth();

    const getData = async () => {

        const { data } = await api.get(`guest/offer-laptop`);
        return data;
    };

    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: ['laptopOffers'],
        queryFn: getData,
        retry: false,
    });
};


export const useSearchLaptop = (searchTerm = null, price_from = null, price_to = null, cpu = null, ram_from = null, ram_to = null, company = null, page = 1) => {
    const api = useAxiosWithAuth();

    const getData = async ({ queryKey }) => {
        const [_key, searchTerm, price_from, price_to, cpu, ram_from, ram_to, company, page] = queryKey;

        const { data } = await api.get(`guest/laptops`, {
            params: {
                searchTerm,
                price_from,
                price_to,
                cpu,
                ram_from,
                ram_to,
                company,
                page,
                // perPage: 5
            },
        });
        return data;
    };

    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: ['search-laptop', searchTerm, price_from, price_to, cpu, ram_from, ram_to, company, page],
        queryFn: getData,
        retry: false,
    });
};